<ng-template>
   <div lcsSingleSelectPanel [visible]="isPanelVisible">
      @if (isIncludeEmptyOption) {
      <lcs-option></lcs-option>
      } @for (status of faxStatuses$ | async; track trackBy(status)) {
      <lcs-option [value]="status" id="lcs-option-id-{{ status.typeName }}">
         {{ status.typeName | addSpaces }}
      </lcs-option>
      }
   </div>
</ng-template>
